import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const BankCodeIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M12.8327 10.0833H7.33268M9.16602 13.75H7.33268M14.666 6.41667H7.33268M18.3327 9.625V6.23333C18.3327 4.69319 18.3327 3.92312 18.033 3.33486C17.7693 2.81741 17.3486 2.39672 16.8312 2.13306C16.2429 1.83333 15.4728 1.83333 13.9327 1.83333H8.06602C6.52587 1.83333 5.7558 1.83333 5.16754 2.13306C4.6501 2.39672 4.2294 2.81741 3.96575 3.33486C3.66602 3.92312 3.66602 4.69319 3.66602 6.23333V15.7667C3.66602 17.3068 3.66602 18.0769 3.96575 18.6651C4.2294 19.1826 4.6501 19.6033 5.16754 19.8669C5.7558 20.1667 6.52587 20.1667 8.06602 20.1667H10.541M20.166 20.1667L18.791 18.7917M19.7077 16.5C19.7077 18.2719 18.2713 19.7083 16.4993 19.7083C14.7274 19.7083 13.291 18.2719 13.291 16.5C13.291 14.7281 14.7274 13.2917 16.4993 13.2917C18.2713 13.2917 19.7077 14.7281 19.7077 16.5Z"
        stroke="#14191F"
        strokeOpacity="0.8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default BankCodeIcon;
